import { useQuery } from "@tanstack/react-query";
import { ServiceResponse } from "andculturecode-javascript-core";
import { QUERY_KEYS } from "data/data-access-hooks/query-keys";
import { EventRecord } from "models/view-models/events/event-record";
import { t } from "utilities/localization/t";
import { ListEventsQueryParams } from "utilities/services/events/event-service";

export const useGetProviderYearEvents = (
    queryFn: (params?: ListEventsQueryParams) => Promise<ServiceResponse<EventRecord>>,
    providerId?: number,
    year?: number
) =>
    useQuery({
        queryKey: [QUERY_KEYS.EVENT_LIST, { providerId, year }],
        queryFn: async () => {
            const response = await queryFn({ providerId, year });
            if (
                response.status >= 400 ||
                response.result?.hasErrors() ||
                response.results?.hasErrors()
            ) {
                throw new Error(t("thereWasAProblemReturningEvents"));
            }
            return response.resultObjects;
        },
        staleTime: Infinity,
        retry: false,
        retryOnMount: false,
        refetchOnMount: false,
        enabled:
            providerId != null &&
            Number.isInteger(providerId) &&
            providerId > 0 &&
            year != null &&
            Number.isInteger(year) &&
            year > 0,
    });
